// Import Vue
import Vue from 'vue';

// Import Framework7
import Framework7 from 'framework7/framework7-lite.esm.bundle.js';

// Import Framework7-Vue Plugin
import Framework7Vue from 'framework7-vue/framework7-vue.esm.bundle.js';
import VueClipboard from 'vue-clipboard2'
import VueSocketIO from 'vue-socket.io'
// import store from './store'

Vue.use(VueClipboard)
// Import Framework7 Styles
import 'framework7/css/framework7.bundle.css';

// Import Icons and App Custom Styles
import '../css/icons.css';
import '../css/app.css';
import '../assets/fontawesome/css/all.css';
import Languages from '../js/languages.js';
import configSite from '../js/config.js';

var domain = location.host;
var config = configSite['*'];
if(configSite[domain]){
  config = configSite[domain]
}
var folder_alias = '';
if(config.service_alias == 'live'){
  folder_alias = '_'+config.service_alias;
}
// var connectionOptions =  {
//             "force new connection" : true,
//             "reconnectionAttempts": "Infinity", //avoid having user reconnect manually in order to prevent dead clients after a server restart
//             "timeout" : 10000, //before connect_error and connect_timeout are emitted.
//             "transports" : ["websocket"]
//         };
// Vue.use(new VueSocketIO({
//   debug: true,
//   connection: configSite.socket_url,
//   options: connectionOptions
// }))
// Import App Component
// const app_alias = '../components/app'+folder_alias+'.vue'
// console.log('../components/app'+folder_alias+'.vue')
import App from '../components/app.vue';
import AppLive from '../components/app_live.vue';
import AppLiveVIP from '../components/app_live_vip.vue';
import AppLiveTiktok from '../components/app_live_tiktok.vue';

// Init Framework7-Vue Plugin
Framework7.use(Framework7Vue);

// Init App
new Vue({
  el: '#app',
  // store,
  // render: (h) => h(App),
  render(h){
    if(config.service_alias == 'live'){
      return h(AppLive)
    }else if(config.service_alias == 'live_vip'){
      return h(AppLiveVIP)
    }else if(config.service_alias == 'live_tiktok'){
      return h(AppLiveTiktok)
    }else{
      return h(App)
    }
    
  },

  // Register App Component
  components: {
    app: App
  },
  	data: function () {
      var supplier = config.supplier;
      var lang_default = config.lang_default;
      var managerSite = {};
      var paymentData = {};
      var contacts = {};
      var qr_logo = configSite.qr_logo;
      if(config.service_alias == 'minutes'){
        qr_logo = configSite.qr_logo_ab;
      }
      managerSite[domain] = config.managerSite;
      paymentData[domain] = config.paymentData;
      contacts[domain] = config.contacts;

      return {
        socket: null,
      	name: config.name,
      	theme: 'ios', // Automatic theme detection
				autoDarkTheme: true,
        darkTheme: false,
        color_theme: 'deeppurple',
        color_theme_app: 'deeppurple',
				lang: lang_default,
				languages: Languages,
      	// supplier: "5da30e788bcd9405cce88912",
      	// managerSite: 'https://fbvideoview.com/',
        	// apiurlRoot: 'http://localhost:8543/',
        	// apiurl: 'http://localhost:8543/webapp',

          apiurlRoot: configSite.main_url,
          apiurl: configSite.main_url+'/webapp',
       // services: ["617595711a7a736617ec3af9","604893655348bf0471740da9","617595481a7a736617ec3af8"],
      	supplier: supplier,
        	managerSite: managerSite,
        // 	apiurlRoot: 'https://api.amazingcpanel.com/',
        // apiurl: 'https://api.amazingcpanel.com/webapp',
        socket_url: configSite.socket_url,
        services: config.services,
        service_alias: config.service_alias,
        folder_alias: folder_alias,
      	paymentData: paymentData,
        viewersavailable: -1,
        viewersavailable_admin: -1,
        cookie_string: '',
        socket_running: false,
        contacts: contacts,
        qr_logo: qr_logo,
        qr_data: configSite.qr_data,
        video_get_cookie: [
          {
            html: '<iframe width="560" height="315" src="https://www.youtube.com/embed/_9F-6GEH1i8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
            // caption: 'Woodkid - Run Boy Run (Official HD Video)'
          },
        ],
      }
   	},
  	methods: {
      	onCopySuccess: function (e) {
      		const self = this; 
      		var dialog = self.$f7.dialog.create({
			  title: self.setLang('copied'),
			  text: e.text, 
			  animate: true,
			  on: {
			    opened: function () {
			      // console.log('Dialog opened')
			    }
			  }
			})
			dialog.open()
      		setTimeout(function(){
      			dialog.close();
      		}, 1000)
    	},
    	onCopyError: function (e) {
      		const self = this; 
      		var dialog = self.$f7.dialog.create({
			  title: self.setLang('error'),
			  text: self.setLang('can_not_copy'), 
			  animate: true,
			  on: {
			    opened: function () {
			      // console.log('Dialog opened')
			    }
			  }
			})
			dialog.open()
      		setTimeout(function(){
      			dialog.close();
      		}, 1000)
      		// self.$f7.dialog.alert('Không sao chép được','Lỗi')
    	},
      setupSocket(){
        const self = this; 
        const app = self.$f7;
        if(app.data.user && app.data.user.token && app.data.user.token != ""){
          
          if(!self.$root.socket_running){
            self.$root.socket_running = true;
            var connectionOptions =  {
              // "force new connection" : true,
              // "reconnectionAttempts": "Infinity", //avoid having user reconnect manually in order to prevent dead clients after a server restart
              // "timeout" : 10000, //before connect_error and connect_timeout are emitted.
              // "transports" : ["websocket"],
              query: {
                token: app.data.user.token
              }
              // "data": {"ip":1,"oc":"ls"},
            };
            // Vue.use(new VueSocketIO({
            //   debug: false,
            //   connection: configSite.socket_url,
            //   options: connectionOptions,
            // }))
    //         self.$socket.emit('joinall',{})
          }
        }else{
          self.$root.socket_running = false;
        }
      },
    	copyText(text){
      		const self = this; 
    		let container = self.$refs.container;
    		self.$copyText(text, container).then(self.onCopySuccess, self.onCopyError);
    	},
    	setLang(lange_alias){
      	const self = this; 
      	try{
      		if(typeof self.$root.languages[self.$root.lang][lange_alias] !== 'undefined'){
      			return self.$root.languages[self.$root.lang][lange_alias];
      		}else{
      			return 'not_lang: '+lange_alias;
      		}
      		
      	}catch(e){
      		return 'undefined'
      	}
    		
    	},
      changeDark(){
        const self = this; 
        const app = self.$f7;
        self.darkTheme = !self.darkTheme;
        app.form.storeFormData('darkTheme', self.darkTheme);
        self.setColorTheme();
      },
      setColorTheme(){
        const self = this; 
        var theme_color = "#254892"
        if(!self.darkTheme){
          self.color_theme_app = 'deeppurple';
          self.color_theme = 'deeppurple';
        }else{
          self.color_theme_app = 'white';
          self.color_theme = 'gray';
          theme_color = "#000"
        }
        self.changeThemeColor(theme_color)
      },
      changeThemeColor(color) {
        const self = this; 
        self.$$('meta[name=theme-color]').attr('content', color);
        self.$$('body').css('background-color', color);
      },
      changeLang(lang){
        const self = this; 
        const app = self.$f7;
        self.$root.lang = lang;
        app.form.storeFormData('lang', lang);
      },
      changePage(){
        const self = this; 
        const app = self.$f7;
        app.form.storeFormData('last_page_name', app.views.current.name);
      },
    	getNameService: function(service){
      	const self = this; 
        return self.setLang('service_'+service.id);
        // if(service.id == 111){
        //   return self.setLang('service_111');
        // }else if(service.id == 68){
        //   return self.setLang('service_68');
        // }else if(service.id == 60){
        //   return self.setLang('service_60');
        // }
        return "undefined";
      },
      getViewerAvailable: function(){
        const self = this; 
        const app = self.$f7;
        if(self.viewersavailable != -1 && self.viewersavailable < 1000){
          self.viewersavailable = 0;
        }
        try{
          if(app.data.user.roles.indexOf('admin') != -1){
            return ' ('+self.setLang('available')+' <span style="color: #ff6b22; font-weight: bold;">'+self.viewersavailable_admin+'</span> '+self.setLang('viewers')+')';
          }else if(self.viewersavailable == -1){
            return ' ('+self.setLang('viewers_available_updating')+')';
          }else if(self.viewersavailable == 0){
            return ' ('+self.setLang('viewers_not_available')+')';
          }else{
            return ' ('+self.setLang('available')+' <span style="color: #ff6b22; font-weight: bold;">'+self.viewersavailable+'</span> '+self.setLang('viewers')+')';
          }
        }catch(e){
          setTimeout(self.getViewerAvailable, 100);
        }
      },
      getString: function(test_str, text_begin, text_end){
        if(!test_str || test_str == ""){
          return '';
        }
        var start_pos = test_str.toString().indexOf(text_begin);
        if(start_pos < 0){
          return '';
        }
        start_pos += text_begin.length;
        var end_pos = test_str.indexOf(text_end,start_pos);
        var text_to_get = test_str.substring(start_pos,end_pos);
        return text_to_get;
      },
      setPrice: function (price){
        const self = this;
        const app = self.$f7;
        price = price*self.$f7.data.user.cost_scale
        // var language_alias_current = 'us';
        var language_alias_current = self.$root.lang;
        try{
          // language_alias_current = localStorage.getItem('language');
        }catch(e){}
        if(language_alias_current == 'vn'){
          var new_price = (parseFloat(price*20000).toFixed(0));
          if(parseFloat(new_price) < parseFloat(parseFloat(price*20000).toFixed(1))){
            new_price = (parseFloat(price*20000).toFixed(1));
          }
          if(parseFloat(new_price) < parseFloat(parseFloat(price*20000).toFixed(2))){
            new_price = (parseFloat(price*20000).toFixed(2));
          }
          if(price < 0){
            return self.formatNumber(new_price,'.',',')
              // return '-'+(-new_price).toLocaleString('it-IT', {style : 'currency', currency : 'VND'});
          }
          return self.formatNumber(new_price,'.',',')
          // return new_price.toLocaleString('it-IT', {style : 'currency', currency : 'VND'});
        }else{
          var price_float = parseFloat(price).toFixed(7);
          var price_int = parseInt(price);
          if(price_int == price_float){
            price_float = price_int;
          }
          // price_float = self.formatNumber(price_float,'.',',')
          // if(price < 0){
          //     return '-$'+(-price_float);
          // }
          // return '$'+price_float;
          if(price_float < 0){
            return '-'+self.formatNumberUSD(-price_float,'.',',')
          }
          return self.formatNumberUSD(price_float,'.',',')
        }
      },
      formatNumber: function (nStr, decSeperate, groupSeperate) {
        nStr += '';
        var x = nStr.split(decSeperate);
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + groupSeperate + '$2');
        }
        return x1 + x2+' đ';
      },
      formatNumberUSD: function (nStr, decSeperate, groupSeperate) {
        nStr += '';
        var x = nStr.split(decSeperate);
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + groupSeperate + '$2');
        }
        return '$'+x1 + x2;
      },
      setPriceNotification: function (price){
        const self = this;
        var new_price = self.setPrice(price);
        if(price < 0){
          return new_price;
        }else{
          return '+'+new_price;
        }
      },
      setPricePayment: function (price){
        const self = this;
        var new_price = self.setPrice(price);
        if(price < 0){
          return new_price;
        }else{
          return '+'+new_price;
        }
      },
      setLanguage: function (this_state,title) {
        const self = this;
        try{
            if(typeof self.language[this_state] !== 'undefined'){
                return self.language[this_state];
            }
        }catch(e){
        }
        return title;
      },
      setLanguageNotification: function (notification){
        const self = this;
          var new_title = '';
          if(notification){
          var key_lange = 'notifications_'+notification.type.replace(/\./g,'_');
          // console.log(self);
          // return'';
          try{
          switch(notification.type.replace(/\./g,'_')) {
            case 'orders_created':
              // code block
              new_title = self.setLang(key_lange, 'Đơn hàng #{main_id} trong {service} bởi {userApply} vừa được đặt.');
              break;
            case 'orders_restarted':
              // code block
              new_title = self.setLang(key_lange, 'Đơn hàng #{main_id} bởi {userApply} vừa chạy lại.');
              break;
            case 'orders_cancelled':
              new_title = self.setLang(key_lange, 'Đơn hàng #{main_id} bởi {userApply} đã bị huỷ.');
              break;
            case 'orders_deleted':
              new_title = self.setLang(key_lange, 'Đơn hàng #{main_id} bởi {userApply} đã bị xoá.');
              break;
            case 'orders_completed':
              new_title = self.setLang(key_lange, 'Đơn hàng #{main_id} bởi {userApply} đã hoàn thành.');
              break;
            case 'orders_refundtimelive':
              new_title = self.setLang(key_lange, 'Đơn hàng #{main_id} của {userApply} livestream chưa hết thời gian đã cài.');
              break;
            case 'orders_renew':
              new_title = self.setLang(key_lange, 'Đơn hàng #{main_id} trong {service} đã tự động tạo mới.');
              break;
            case 'payments_payment':
              new_title = self.setLang(key_lange, '{userApply} {price} trong ví {service}. {userApply} đã thanh toán cho đơn hàng #{main_id}.');
              break;
            case 'payments_refund':
              new_title = self.setLang(key_lange, '{userApply} {price} trong ví {service}. {userApply} đã nhận tiền hoàn lại từ đơn hàng #{main_id}.');
              break;
            case 'payments_refundtimelive':
              new_title = self.setLang(key_lange, '{userApply} {price}. {userApply} hoàn tiền cho đoen hàng #{main_id} livestream chưa hết thời gian đã cài.');
              break;
            case 'payments_addfund':
              new_title = self.setLang(key_lange, '{userApply} {price} trong ví {service}. {userApply} đã nạp tiền qua {payment_method}.');
              break;
            case 'payments_receivefund':
              new_title = self.setLang(key_lange, '{userApply} {price} trong ví {service}. {userApply} nhận tiền từ {user_more} qua {payment_method}.');
              break;
            case 'payments_receive':
              new_title = self.setLang(key_lange, '{userApply} {price} trong ví {service}. {user_more} đã xác nhận thanh toán qua {payment_method}.');
              break;
            case 'payments_sent':
              new_title = self.setLang(key_lange, '{userApply} {price} trong ví {service}. {userApply} đã gửi cho {user_more} qua {payment_method}.');
              break;
            case 'payments_transfer_from':
              new_title = self.setLang(key_lange, '{userApply} {price} trong ví {service}. {userApply} đã thanh toán cho yêu cầu chuyển tiền từ {service_old} qua {service_new}.');
              break;
            case 'payments_transfer_to':
              new_title = self.setLang(key_lange, '{userApply} {price} trong ví {service}. {userApply} đã nhận được thanh toán cho yêu cầu chuyển tiền từ  {service_old} qua {service_new}.');
              break;
            case 'payments_transfer_pending':
              new_title = self.setLang(key_lange, '{user_more} vừa tạo yêu cầu chuyển tiền từ {service_old} qua {service_new}. {userApply} cần xác nhận yêu cầu này cho {user_more} với số tiền {price}.');
              break;
            case 'payments_payment_promotion':
              new_title = self.setLang(key_lange, '{userApply} {price}. {userApply} thanh toán cho khuyến mãi #{main_id}.');
              break;
            case 'promotions.buy':
              new_title = self.setLang(key_lange, 'Khuyến mãi #{main_id} đã được mua bởi {userApply}.');
              break;
            case 'payments_sell_promotion':
              new_title = self.setLang(key_lange, '{userApply} {price}. {userApply} đã bán mã khuyến mãi #{main_id}.');
              break;
            case 'promotions_sell':
              new_title = self.setLang(key_lange, 'Khuyến mãi #{main_id} được bán bởi {userApply} cho {{user_more}}.');
              break;
            case 'users_register':
              new_title = self.setLang(key_lange, '{user_more} vừa đăng ký thành viên. {userApply} là người quản lý cho {user_more}.');
              break;
            case 'promotions_reward':
              new_title = self.setLang(key_lange, '{userApply} đã nhận được mã khuyến mãi {promotion}..');
              break;
            default:
              // code block
          }
        }catch(e){
          // console.log(e,notification.type)
        }
        // console.log(notification)
          try{
          new_title = new_title.replace(/{userApply}/g, notification.userApply.username)
          }catch(e){}
          try{
          new_title = new_title.replace(/{user_more}/g, notification.user_more.username)
          }catch(e){}
          try{
          new_title = new_title.replace(/{payment_method}/g, notification.payment_method)
          }catch(e){}
          try{
            if(notification.price < 0){
              new_title = new_title.replace(/{price}/g, self.setPriceNotification(notification.price))
            }else{
              new_title = new_title.replace(/{price}/g, self.setPriceNotification(notification.price))
            }
          }catch(e){}
          try{
          new_title = new_title.replace(/{promotion}/g, notification.promotion.code)
          }catch(e){}
          try{
          new_title = new_title.replace(/{main_id}/g, notification.main_id)
          }catch(e){}
          try{
          new_title = new_title.replace(/{service}/g, notification.service.name)
          }catch(e){}
          try{
          new_title = new_title.replace(/{service_old}/g, notification.service_old.name)
          }catch(e){}
          try{
          new_title = new_title.replace(/{service_new}/g, notification.service_new.name)
          }catch(e){}
          // try{
          // new_title = new_title.replace(/{userApply}/g, '<span style="font-weight: bold;">'+notification.userApply.username+'</span>')
          // }catch(e){}
          // try{
          // new_title = new_title.replace(/{user_more}/g, '<span style="font-weight: bold;">'+notification.user_more.username+'</span>')
          // }catch(e){}
          // try{
          // new_title = new_title.replace(/{payment_method}/g, '<span style="font-weight: bold;">'+notification.payment_method+'</span>')
          // }catch(e){}
          // try{
          //   if(notification.price < 0){
          //     new_title = new_title.replace(/{price}/g, '<span style="font-weight: bold; color: #ed2839;">'+self.setPriceNotification(notification.price)+'</span>')
          //   }else{
          //     new_title = new_title.replace(/{price}/g, '<span class="my_balance_earn" style="font-weight: bold;">'+self.setPriceNotification(notification.price)+'</span>')
          //   }
          // }catch(e){}
          // try{
          // new_title = new_title.replace(/{promotion}/g, '<span style="font-weight: bold;">'+notification.promotion.code+'</span>')
          // }catch(e){}
          // try{
          // new_title = new_title.replace(/{main_id}/g, '<span style="font-weight: bold;">'+notification.main_id+'</span>')
          // }catch(e){}
          // try{
          // new_title = new_title.replace(/{service}/g, '<span style="font-weight: bold;">'+notification.service.name+'</span>')
          // }catch(e){}
          // try{
          // new_title = new_title.replace(/{service_old}/g, '<span style="font-weight: bold;">'+notification.service_old.name+'</span>')
          // }catch(e){}
          // try{
          // new_title = new_title.replace(/{service_new}/g, '<span style="font-weight: bold;">'+notification.service_new.name+'</span>')
          // }catch(e){}
          // var d = new Date(notification.created);
          // var dateString = self.formatDate(d);
          // var dateString = notification.created;
          // return new_title+'<br/><span style="font-style: italic; color: #009639;">'+dateString+'</span>';
        }
          return new_title;
      },
      formatDate: function(date) {
        var monthNames = [
          "1", "2", "3",
          "4", "5", "6", "7",
          "8", "9", "10",
          "11", "12"
        ];

        var minute = date.getMinutes();
        var hour = date.getHours();
        var day = date.getDate();
        var monthIndex = date.getMonth();
        var year = date.getFullYear();

        // return  hour + ':' +minute + ' ' +  monthNames[monthIndex]+ ' ' +day ;
        return  day + '/' +  monthNames[monthIndex] + ' '+hour + ':' +minute ;
      },

      getAccesstokenFromHtml(html){
        var self = this;
        var app = self.$f7;
        if((html.indexOf('EAAGNO') > -1 || html.indexOf('EAAGNO') > -1) && (html.indexOf(',') > -1 || html.indexOf('"') > -1)){
          var accesstoken = self.getString(html,'EAAGNO','"');
          if(accesstoken == ''){
            accesstoken = self.getString(html,'EAAGNO','"');
            if(accesstoken == ''){
              return self.setLang('accesstoken_can_not_detect')
            }else{
              accesstoken = 'EAAGNO'+accesstoken;
              return accesstoken;
            }
          }else{
            accesstoken = 'EAAGNO'+accesstoken;
            return accesstoken;
          }
        }else{
          return html
        }
      },
      // promotion
      loadMorePromotions(callback) {
        const self = this;
        var app = self.$f7;
        app.request.post(self.$root.$f7.params.apiurl, {action: 'promotionlist', supplier: self.$root.supplier, token: app.data.user.token}, function(data){
          var promotions = data.data;
          var promotions_new = [];
          for (var i = 0; i < promotions.length; i++) {
            if(self.checkServicePromotion(self.$root.services,promotions[i].service_ids)){
              promotions_new.push(promotions[i])
            }
          }
          promotions = promotions_new;
          callback(promotions);
        },
        function(err){
          // callback(false);
          setTimeout(function(){
            self.loadMorePromotions(callback);
          }, 3000)
        },'json');
      },

      activePromotion(code,callback) {
        const self = this;
        var app = self.$f7;
        app.request.post(self.$root.$f7.params.apiurl, {action: 'promotionapply', code: code,supplier: self.$root.supplier, token: app.data.user.token}, function(data){
          callback(data)
        },
        function(err){
          setTimeout(function(){
            self.activePromotion(callback);
          }, 3000)
        },'json');
      },
      checkServicePromotion(services_root, service_ids){
        var status = false;
        var list_service = service_ids.split(',');
        for (var i = 0; i < list_service.length; i++) {
          if(services_root.indexOf(list_service[i]) != -1){
            status = true;
            break;
          }
        }
        return status
      },
      getDesPromotion(apromotion, is_html){
        const self = this;
        var app = self.$f7;
        var enable_html = false;
        if(is_html){
          enable_html = true;
        }
        try{
        var description =  '';
        var expired_hour = '';
        if(apromotion.is_package == 1){
          description =  self.setLang('promotions_description');
          expired_hour = apromotion.package_hour+' '+self.setLang('promotions_hours');
          if(apromotion.package_hour % 24 == 0){
            expired_hour = apromotion.package_hour/24;
            if(expired_hour == 1){
              expired_hour += ' '+self.setLang('promotions_day');
            }else{
              expired_hour += ' '+self.setLang('promotions_days');
            }
          }
          //return formatNumberPromotion(new_price,'.',',')
          if(apromotion.amount_max > 0){
            description += ' '+self.setLang('promotions_amount_max');
            if(enable_html){
              description = description.replace(/{view_remain}/g,'<span style="color: #00f;font-weight: bold;">'+self.formatNumberPromotion(apromotion.amount_max,'.',',')+'</span>')
            }else{
              description = description.replace(/{view_remain}/g,self.formatNumberPromotion(apromotion.amount_max,'.',','))
            }
          }
        }else{
          if(apromotion.service_ids == "*"){
            description =  self.setLang('promotions_description_package');
          }else{
            description =  self.setLang('promotions_description_package');
          }
          if(apromotion.condition_min_price > 0){
            description += ' '+self.setLang('promotions_description_min_price');
          }
          if(apromotion.amount_max > 0){
            // description += ' '+$rootScope.setLanguage('promotions.amount_remain', "Remain "+(apromotion.amount_max-apromotion.amount_used)+'/'+apromotion.amount_max);
            description += ' '+self.setLang('promotions_amount_remain');
            if(enable_html){
              description = description.replace(/{view_remain}/g,'<span style="color: #00f;font-weight: bold;">'+self.formatNumberPromotion(apromotion.amount_max-apromotion.amount_used,'.',',')+'</span>')
            }else{
              description = description.replace(/{view_remain}/g,self.formatNumberPromotion(apromotion.amount_max-apromotion.amount_used,'.',','))
            }
            
          }
        }
        var service_names = apromotion.service_names;
        var your_balance = app.data.userbalance.balances;
          var your_balance_new = [];
          for (var i = 0; i < your_balance.length; i++) {
            if(self.$root.services.indexOf(your_balance[i].service_id._id) != -1){
              your_balance_new.push(your_balance[i])
            }
          }
          your_balance = your_balance_new;
        var service_array_name = [];
        for (var i = 0; i < your_balance.length; i++) {
          if(apromotion.service_ids.indexOf(your_balance[i].service_id._id) > -1){
            service_array_name.push(self.getNameService(your_balance[i].service_id));
          }
        }
        service_names = service_array_name.join(', ')
        if(service_names == '*'){
          service_names = self.setLang('promotions_all');
        }
        // console.log('service_array_name',service_array_name)
        if(enable_html){
          description = description.replace(/{value}/g,'<span style="color: #f00;font-weight: bold;">'+self.getCoverPromotion(apromotion)+'</span>')
              .replace(/{service}/g,'<span style="color: #3C4043;font-weight: 500;">'+service_names+'</span>')
              .replace(/{min_price}/g,'<span style="color: #f00;font-weight: bold;">'+self.setPrice(apromotion.condition_min_price)+'</span>')
              .replace(/{pack_time}/g, '<span style="color: #f00;font-weight: bold;">'+expired_hour+'</span>')
            }else{
               description = description.replace(/{value}/g,self.getCoverPromotion(apromotion))
              .replace(/{service}/g,service_names)
              .replace(/{min_price}/g,self.setPrice(apromotion.condition_min_price))
              .replace(/{pack_time}/g, expired_hour)
            }
        return description;

        }catch(e){
          setTimeout(function(){
            self.getDesPromotion(apromotion)
          }, 10)
        }
      },
      formatNumberPromotion(nStr, decSeperate, groupSeperate) {
        const self = this;
          nStr += '';
          var x = nStr.split(decSeperate);
          var x1 = x[0];
          var x2 = x.length > 1 ? '.' + x[1] : '';
          var rgx = /(\d+)(\d{3})/;
          while (rgx.test(x1)) {
              x1 = x1.replace(rgx, '$1' + groupSeperate + '$2');
          }
          return x1 + x2;
      },
      getCoverPromotion(apromotion){
        const self = this;
        try{
          if(apromotion.is_package == 1){
              if(apromotion.value == 100){
                return self.setLang('promotions_free');
              }else{
                return '-'+apromotion.value+'%';
              }
          }else{
            if(apromotion.is_percent == 1){
              return '-'+apromotion.value+'%';
            }else{
              return '-'+self.setPrice(promotions.value)
            }
          }
        }catch(e){
          setTimeout(function(){
            self.getCoverPromotion(apromotion)
          }, 10)
        }
      },

      formatDatePromotion(datestamp) {
        // var monthNames = [
        //   "Jan", "Feb", "Mar",
        //   "Apr", "May", "Jun", "Jul",
        //   "Aug", "Sep", "Oct",
        //   "Nov", "Dec"
        // ];
        var date = new Date(datestamp)
        // console.log(date)
        // return date;
        var monthNames = [
          "01", "02", "03",
          "04", "05", "06", "07",
          "08", "09", "10",
          "11", "12"
        ];

        var minute = date.getMinutes();
        var hour = date.getHours();
        var day = date.getDate();
        var monthIndex = date.getMonth();
        var year = date.getFullYear();

        // return  hour + ':' +minute + ' ' +  monthNames[monthIndex]+ ' ' +day ;
        return  day + '/' +  monthNames[monthIndex] + '/'+year;
      },
      getBankDetail(){
        var dataBank = {"vietinbank":{"bin":"970415","code":"ICB","id":17,"isTransfer":1,"name":"Ngân hàng TMCP Công thương Việt Nam","short_name":"VietinBank","support":3},"vietcombank":{"bin":"970436","code":"VCB","id":43,"isTransfer":1,"name":"Ngân hàng TMCP Ngoại Thương Việt Nam","short_name":"Vietcombank","support":3},"mbbank":{"bin":"970422","code":"MB","id":21,"isTransfer":1,"name":"Ngân hàng TMCP Quân đội","short_name":"MBBank","support":3},"acb":{"bin":"970416","code":"ACB","id":2,"isTransfer":1,"name":"Ngân hàng TMCP Á Châu","short_name":"ACB","support":3},"vpbank":{"bin":"970432","code":"VPB","id":47,"isTransfer":1,"name":"Ngân hàng TMCP Việt Nam Thịnh Vượng","short_name":"VPBank","support":3},"tpbank":{"bin":"970423","code":"TPB","id":39,"isTransfer":1,"name":"Ngân hàng TMCP Tiên Phong","short_name":"TPBank","support":3},"msb":{"bin":"970426","code":"MSB","id":22,"isTransfer":1,"name":"Ngân hàng TMCP Hàng Hải","short_name":"MSB","support":3},"namabank":{"bin":"970428","code":"NAB","id":23,"isTransfer":1,"name":"Ngân hàng TMCP Nam Á","short_name":"NamABank","support":3},"lienvietpostbank":{"bin":"970449","code":"LPB","id":20,"isTransfer":1,"name":"Ngân hàng TMCP Bưu Điện Liên Việt","short_name":"LienVietPostBank","support":3},"vietcapitalbank":{"bin":"970454","code":"VCCB","id":44,"isTransfer":1,"name":"Ngân hàng TMCP Bản Việt","short_name":"VietCapitalBank","support":3},"bidv":{"bin":"970418","code":"BIDV","id":4,"isTransfer":1,"name":"Ngân hàng TMCP Đầu tư và Phát triển Việt Nam","short_name":"BIDV","support":3},"sacombank":{"bin":"970403","code":"STB","id":36,"isTransfer":1,"name":"Ngân hàng TMCP Sài Gòn Thương Tín","short_name":"Sacombank","support":3},"vib":{"bin":"970441","code":"VIB","id":45,"isTransfer":1,"name":"Ngân hàng TMCP Quốc tế Việt Nam","short_name":"VIB","support":3},"hdbank":{"bin":"970437","code":"HDB","id":12,"isTransfer":1,"name":"Ngân hàng TMCP Phát triển Thành phố Hồ Chí Minh","short_name":"HDBank","support":3},"seabank":{"bin":"970440","code":"SEAB","id":33,"isTransfer":1,"name":"Ngân hàng TMCP Đông Nam Á","short_name":"SeABank","support":3},"gpbank":{"bin":"970408","code":"GPB","id":11,"isTransfer":0,"name":"Ngân hàng Thương mại TNHH MTV Dầu Khí Toàn Cầu","short_name":"GPBank","support":1},"pvcombank":{"bin":"970412","code":"PVCB","id":30,"isTransfer":1,"name":"Ngân hàng TMCP Đại Chúng Việt Nam","short_name":"PVcomBank","support":3},"ncb":{"bin":"970419","code":"NCB","id":24,"isTransfer":1,"name":"Ngân hàng TMCP Quốc Dân","short_name":"NCB","support":3},"shinhanbank":{"bin":"970424","code":"SHBVN","id":37,"isTransfer":1,"name":"Ngân hàng TNHH MTV Shinhan Việt Nam","short_name":"ShinhanBank","support":3},"scb":{"bin":"970429","code":"SCB","id":31,"isTransfer":1,"name":"Ngân hàng TMCP Sài Gòn","short_name":"SCB","support":3},"pgbank":{"bin":"970430","code":"PGB","id":29,"isTransfer":1,"name":"Ngân hàng TMCP Xăng dầu Petrolimex","short_name":"PGBank","support":3},"agribank":{"bin":"970405","code":"VBA","id":42,"isTransfer":0,"name":"Ngân hàng Nông nghiệp và Phát triển Nông thôn Việt Nam","short_name":"Agribank","support":0},"techcombank":{"bin":"970407","code":"TCB","id":38,"isTransfer":1,"name":"Ngân hàng TMCP Kỹ thương Việt Nam","short_name":"Techcombank","support":3},"saigonbank":{"bin":"970400","code":"SGICB","id":34,"isTransfer":1,"name":"Ngân hàng TMCP Sài Gòn Công Thương","short_name":"SaigonBank","support":3},"dongabank":{"bin":"970406","code":"DOB","id":9,"isTransfer":0,"name":"Ngân hàng TMCP Đông Á","short_name":"DongABank","support":0},"bacabank":{"bin":"970409","code":"BAB","id":3,"isTransfer":0,"name":"Ngân hàng TMCP Bắc Á","short_name":"BacABank","support":0},"standardchartered":{"bin":"970410","code":"SCVN","id":32,"isTransfer":0,"name":"Ngân hàng TNHH MTV Standard Chartered Bank Việt Nam","short_name":"StandardChartered","support":0},"oceanbank":{"bin":"970414","code":"Oceanbank","id":27,"isTransfer":0,"name":"Ngân hàng Thương mại TNHH MTV Đại Dương","short_name":"Oceanbank","support":0},"vrb":{"bin":"970421","code":"VRB","id":48,"isTransfer":0,"name":"Ngân hàng Liên doanh Việt - Nga","short_name":"VRB","support":0},"abbank":{"bin":"970425","code":"ABB","id":1,"isTransfer":0,"name":"Ngân hàng TMCP An Bình","short_name":"ABBANK","support":0},"vietabank":{"bin":"970427","code":"VAB","id":41,"isTransfer":0,"name":"Ngân hàng TMCP Việt Á","short_name":"VietABank","support":0},"eximbank":{"bin":"970431","code":"EIB","id":10,"isTransfer":0,"name":"Ngân hàng TMCP Xuất Nhập khẩu Việt Nam","short_name":"Eximbank","support":0},"vietbank":{"bin":"970433","code":"VIETBANK","id":46,"isTransfer":1,"name":"Ngân hàng TMCP Việt Nam Thương Tín","short_name":"VietBank","support":3},"indovinabank":{"bin":"970434","code":"IVB","id":18,"isTransfer":0,"name":"Ngân hàng TNHH Indovina","short_name":"IndovinaBank","support":0},"baovietbank":{"bin":"970438","code":"BVB","id":5,"isTransfer":1,"name":"Ngân hàng TMCP Bảo Việt","short_name":"BaoVietBank","support":3},"publicbank":{"bin":"970439","code":"PBVN","id":28,"isTransfer":0,"name":"Ngân hàng TNHH MTV Public Việt Nam","short_name":"PublicBank","support":0},"shb":{"bin":"970443","code":"SHB","id":35,"isTransfer":0,"name":"Ngân hàng TMCP Sài Gòn - Hà Nội","short_name":"SHB","support":0},"cbbank":{"bin":"970444","code":"CBB","id":6,"isTransfer":0,"name":"Ngân hàng Thương mại TNHH MTV Xây dựng Việt Nam","short_name":"CBBank","support":0},"ocb":{"bin":"970448","code":"OCB","id":26,"isTransfer":1,"name":"Ngân hàng TMCP Phương Đông","short_name":"OCB","support":3},"kienlongbank":{"bin":"970452","code":"KLB","id":19,"isTransfer":1,"name":"Ngân hàng TMCP Kiên Long","short_name":"KienLongBank","support":3},"cimb":{"bin":"422589","code":"CIMB","id":7,"isTransfer":0,"name":"Ngân hàng TNHH MTV CIMB Việt Nam","short_name":"CIMB","support":0},"hsbc":{"bin":"458761","code":"HSBC","id":14,"isTransfer":0,"name":"Ngân hàng TNHH MTV HSBC (Việt Nam)","short_name":"HSBC","support":0},"dbsbank":{"bin":"796500","code":"DBS","id":8,"isTransfer":0,"name":"DBS Bank Ltd - Chi nhánh Thành phố Hồ Chí Minh","short_name":"DBSBank","support":0},"nonghyup":{"bin":"801011","code":"NHB HN","id":25,"isTransfer":0,"name":"Ngân hàng Nonghyup - Chi nhánh Hà Nội","short_name":"Nonghyup","support":0},"hongleong":{"bin":"970442","code":"HLBVN","id":13,"isTransfer":0,"name":"Ngân hàng TNHH MTV Hong Leong Việt Nam","short_name":"HongLeong","support":0},"ibkbank":{"bin":"970456","code":"IBK - HCM","id":16,"isTransfer":0,"name":"Ngân hàng Công nghiệp Hàn Quốc - Chi nhánh TP. Hồ Chí Minh","short_name":"IBK Bank","support":0},"woori":{"bin":"970457","code":"WVN","id":49,"isTransfer":0,"name":"Ngân hàng TNHH MTV Woori Việt Nam","short_name":"Woori","support":0},"unitedoverseas":{"bin":"970458","code":"UOB","id":40,"isTransfer":0,"name":"Ngân hàng United Overseas - Chi nhánh TP. Hồ Chí Minh","short_name":"UnitedOverseas","support":0},"kookminhn":{"bin":"970462","code":"KBHN","id":50,"isTransfer":0,"name":"Ngân hàng Kookmin - Chi nhánh Hà Nội","short_name":"KookminHN","support":0},"kookminhcm":{"bin":"970463","code":"KBHCM","id":51,"isTransfer":0,"name":"Ngân hàng Kookmin - Chi nhánh Thành phố Hồ Chí Minh","short_name":"KookminHCM","support":0},"coopbank":{"bin":"970446","code":"COOPBANK","id":52,"isTransfer":0,"name":"Ngân hàng Hợp tác xã Việt Nam","short_name":"COOPBANK","support":0}}
        return dataBank;
      },
      createCRC(s) {
        var crcTable = [0x0000, 0x1021, 0x2042, 0x3063, 0x4084, 0x50a5,0x60c6, 0x70e7, 0x8108, 0x9129, 0xa14a, 0xb16b,0xc18c, 0xd1ad, 0xe1ce, 0xf1ef, 0x1231, 0x0210,0x3273, 0x2252, 0x52b5, 0x4294, 0x72f7, 0x62d6,0x9339, 0x8318, 0xb37b, 0xa35a, 0xd3bd, 0xc39c,0xf3ff, 0xe3de, 0x2462, 0x3443, 0x0420, 0x1401,0x64e6, 0x74c7, 0x44a4, 0x5485, 0xa56a, 0xb54b,0x8528, 0x9509, 0xe5ee, 0xf5cf, 0xc5ac, 0xd58d,0x3653, 0x2672, 0x1611, 0x0630, 0x76d7, 0x66f6,0x5695, 0x46b4, 0xb75b, 0xa77a, 0x9719, 0x8738,0xf7df, 0xe7fe, 0xd79d, 0xc7bc, 0x48c4, 0x58e5,0x6886, 0x78a7, 0x0840, 0x1861, 0x2802, 0x3823,0xc9cc, 0xd9ed, 0xe98e, 0xf9af, 0x8948, 0x9969,0xa90a, 0xb92b, 0x5af5, 0x4ad4, 0x7ab7, 0x6a96,0x1a71, 0x0a50, 0x3a33, 0x2a12, 0xdbfd, 0xcbdc,0xfbbf, 0xeb9e, 0x9b79, 0x8b58, 0xbb3b, 0xab1a,0x6ca6, 0x7c87, 0x4ce4, 0x5cc5, 0x2c22, 0x3c03,0x0c60, 0x1c41, 0xedae, 0xfd8f, 0xcdec, 0xddcd,0xad2a, 0xbd0b, 0x8d68, 0x9d49, 0x7e97, 0x6eb6,0x5ed5, 0x4ef4, 0x3e13, 0x2e32, 0x1e51, 0x0e70,0xff9f, 0xefbe, 0xdfdd, 0xcffc, 0xbf1b, 0xaf3a,0x9f59, 0x8f78, 0x9188, 0x81a9, 0xb1ca, 0xa1eb,0xd10c, 0xc12d, 0xf14e, 0xe16f, 0x1080, 0x00a1,0x30c2, 0x20e3, 0x5004, 0x4025, 0x7046, 0x6067,0x83b9, 0x9398, 0xa3fb, 0xb3da, 0xc33d, 0xd31c,0xe37f, 0xf35e, 0x02b1, 0x1290, 0x22f3, 0x32d2,0x4235, 0x5214, 0x6277, 0x7256, 0xb5ea, 0xa5cb,0x95a8, 0x8589, 0xf56e, 0xe54f, 0xd52c, 0xc50d,0x34e2, 0x24c3, 0x14a0, 0x0481, 0x7466, 0x6447,0x5424, 0x4405, 0xa7db, 0xb7fa, 0x8799, 0x97b8,0xe75f, 0xf77e, 0xc71d, 0xd73c, 0x26d3, 0x36f2,0x0691, 0x16b0, 0x6657, 0x7676, 0x4615, 0x5634,0xd94c, 0xc96d, 0xf90e, 0xe92f, 0x99c8, 0x89e9,0xb98a, 0xa9ab, 0x5844, 0x4865, 0x7806, 0x6827,0x18c0, 0x08e1, 0x3882, 0x28a3, 0xcb7d, 0xdb5c,0xeb3f, 0xfb1e, 0x8bf9, 0x9bd8, 0xabbb, 0xbb9a,0x4a75, 0x5a54, 0x6a37, 0x7a16, 0x0af1, 0x1ad0,0x2ab3, 0x3a92, 0xfd2e, 0xed0f, 0xdd6c, 0xcd4d,0xbdaa, 0xad8b, 0x9de8, 0x8dc9, 0x7c26, 0x6c07,0x5c64, 0x4c45, 0x3ca2, 0x2c83, 0x1ce0, 0x0cc1,0xef1f, 0xff3e, 0xcf5d, 0xdf7c, 0xaf9b, 0xbfba,0x8fd9, 0x9ff8, 0x6e17, 0x7e36, 0x4e55, 0x5e74,0x2e93, 0x3eb2, 0x0ed1, 0x1ef0];
        var crc = 0xFFFF;
        var j, i;
        for (i = 0; i < s.length; i++) {
        var c = s.charCodeAt(i);
        if (c > 255) {
        throw new RangeError();
        }
        j = (c ^ (crc >> 8)) & 0xFF;
        crc = crcTable[j] ^ (crc << 8);
        }
        var final = ((crc ^ 0) & 0xFFFF).toString(16).toString().toUpperCase();
        if(final.length == 0){
          final = "0000";
        }else if(final.length == 1){
          final =  "000"+final;
        }else if(final.length == 2){
          final =  "00"+final;
        }else if(final.length == 3){
          final =  "0"+final;
        }
        return final;
      },

      newMessage(data){
        const self = this;
        const app = self.$f7;
        //self.$root.socket_url+'/'+message.user.profileImageURL
        var notificationWithButton = app.notification.create({
          icon: '<div class="message-avatar" style="background-image: url(&quot;'+data.profileImageURL+'&quot;);width:100%;height:100%;"></div>',
          // title: app.name,
          title: data.title,
          subtitle: data.subtitle,
          // subtitle: data.text,
          text: data.text,
          closeButton: true,
          closeTimeout: 6000,
        });
        notificationWithButton.open();
      },

      encode_utf8(s) {
        return unescape(encodeURIComponent(s));
      },

      decode_utf8(s) {
        // return s;
        try{
          return decodeURIComponent(escape(s));
        }catch(e){
          return s;
        }
        
      },
      // promotion end
  	},
});